import { useQuery } from "@tanstack/react-query";

import { getMetadata } from "./index";

export const useGetMetadata = () => {
  return useQuery({
    queryKey: ["metadata"],
    queryFn: getMetadata,
    staleTime: 1000 * 60 * 60 * 24,
    retry: false,
  });
};
